import React, { useState } from 'react';
import { Container, Card, Button, Alert, ListGroup, Badge } from 'react-bootstrap';

const AdminManualSetup = () => {
  const [adminCode, setAdminCode] = useState('');
  const [showCode, setShowCode] = useState(false);

  const generateCode = () => {
    const code = 'ADMIN' + Math.random().toString(36).substr(2, 8).toUpperCase();
    setAdminCode(code);
    setShowCode(true);
  };

  return (
    <Container className="py-5">
      <Card className="shadow">
        <Card.Header className="bg-warning">
          <h4 className="mb-0">🔧 Admin Setup Instructions</h4>
        </Card.Header>
        <Card.Body>
          <Alert variant="info">
            <strong>Step-by-step guide to set up admin access</strong>
          </Alert>

          <div className="mb-4">
            <h5>1. Generate Admin Code</h5>
            <Button variant="primary" onClick={generateCode} className="mb-3">
              Generate Admin Code
            </Button>
            
            {showCode && (
              <Alert variant="success">
                <h5>Your Admin Code:</h5>
                <code className="fs-4">{adminCode}</code>
                <p className="mt-2 mb-0">
                  <small>Copy this code - you'll need it for admin login</small>
                </p>
              </Alert>
            )}
          </div>

          <div className="mb-4">
            <h5>2. Firebase Console Setup</h5>
            <ListGroup>
              <ListGroup.Item>
                <strong>a.</strong> Go to{' '}
                <a href="https://console.firebase.google.com" target="_blank" rel="noreferrer">
                  Firebase Console
                </a>
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>b.</strong> Select your project
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>c.</strong> Click "Firestore Database" in the left menu
              </ListGroup.Item>
              <ListGroup.Item>
                <strong>d.</strong> Click "Create Collection" (if no collections exist)
              </ListGroup.Item>
            </ListGroup>
          </div>

          <div className="mb-4">
            <h5>3. Create Collections</h5>
            
            <Card className="mb-3">
              <Card.Header className="bg-light">
                <strong>Collection 1: <code>admin_codes</code></strong>
              </Card.Header>
              <Card.Body>
                <p>Collection ID: <Badge bg="secondary">admin_codes</Badge></p>
                <p>Document ID: <Badge bg="info">{adminCode || 'YOUR_GENERATED_CODE'}</Badge></p>
                <p className="mb-1">Fields to add:</p>
                <ul className="small">
                  <li><code>code</code> (string): {adminCode || 'your-code'}</li>
                  <li><code>active</code> (boolean): true</li>
                  <li><code>createdAt</code> (timestamp): [current time]</li>
                  <li><code>maxUses</code> (number): 10</li>
                  <li><code>used</code> (number): 0</li>
                </ul>
              </Card.Body>
            </Card>

            <Card className="mb-3">
              <Card.Header className="bg-light">
                <strong>Collection 2: <code>admin_emails</code></strong>
              </Card.Header>
              <Card.Body>
                <p>Collection ID: <Badge bg="secondary">admin_emails</Badge></p>
                <p>Document ID: <Badge bg="info">example@email.com</Badge></p>
                <p className="mb-1">Fields to add:</p>
                <ul className="small">
                  <li><code>email</code> (string): example@email.com</li>
                  <li><code>role</code> (string): super_admin</li>
                  <li><code>permissions</code> (array): ["dashboard", "rota", "users", "analytics", "settings"]</li>
                  <li><code>createdAt</code> (timestamp): [current time]</li>
                  <li><code>active</code> (boolean): true</li>
                </ul>
              </Card.Body>
            </Card>
          </div>

          <Alert variant="success">
            <h5>✅ Setup Complete!</h5>
            <p className="mb-0">
              After creating these collections, you can use:<br/>
              <strong>Email:</strong> example@email.com<br/>
              <strong>Code:</strong> {adminCode || 'your-generated-code'}
            </p>
          </Alert>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdminManualSetup;